import React, {
  useState,
  useEffect,
  useCallback,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useProgressContext } from '@/contexts/useProgressContext';
import { useAuthState } from '@/plugins/Auth';
import preOrderAPI from '@/api/preOrder';
import Alert from '@/components/Alert';
import RedeemInput from './component/RedeemInput';

const RedeemPage = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { token } = useAuthState();
  const {
    start: startProgress,
    end: endProgress,
  } = useProgressContext();
  const [alert, setAlert] = React.useState(null);
  const [orderId, setOrderId] = useState(null);
  const [redeemCode, setRedeemCode] = useState(null);

  useEffect(() => {
    const {
      redeemCode: redeemCodeFromQueryString,
      orderId: orderIdFromQueryString,
    } = queryString.parse(search || '');
    const newRedeemCode = redeemCodeFromQueryString && redeemCodeFromQueryString.trim();
    const newOrderId = orderIdFromQueryString && orderIdFromQueryString.trim();
    if (newOrderId && orderId !== newOrderId) setOrderId(newOrderId);
    if (newRedeemCode && redeemCode !== newRedeemCode) setRedeemCode(newRedeemCode);
  }, [search, orderId, redeemCode]);

  const startRedeem = useCallback((data = {}, showAlertOnFailed = true) => {
    // Start fetching data from api
    startProgress();
    preOrderAPI.redeem({
      body: {
        ...data,
        token,
      },
    }).then((result) => {
      const {
        status,
        message,
      } = result;
      if (status === 'OK') {
        setAlert({
          title: '折抵成功!',
          message: message || '按下確認返回首頁',
          onConfirm: () => history.replace('/'),
        });
      } else if (showAlertOnFailed) {
        setAlert({
          title: '折抵失敗',
          message: message || '請確認您的訂單編號及取貨碼是否正確。',
        });
      }
    }).finally(() => {
      endProgress();
    });
  }, [endProgress, history, startProgress, token]);

  return (
    <Box
      maxWidth={500}
      mx="auto"
      my={2}
      p={4}
      bgcolor="rgb(242, 242, 242)"
    >
      <RedeemInput
        key={`${orderId}_${redeemCode}`}
        orderId={orderId}
        redeemCode={redeemCode}
        onSubmit={startRedeem}
      />
      {
        alert && (
          <Alert
            isOpen
            title={alert?.title || ''}
            content={alert?.message || ''}
            buttons={alert?.buttons || (
              <>
                <Button fullWidth onClick={() => { window.open('https://eat.freezone.com.tw/adyfA'); }}>
                  <Box fontWeight="fontWeightBold" color="support.main">
                    洽詢專人客服
                  </Box>
                </Button>
                <Button fullWidth onClick={alert?.onConfirm || (() => setAlert(null))}>
                  <Box fontWeight="fontWeightBold" color="support.main">
                    確認
                  </Box>
                </Button>
              </>
            )}
          />
        )
      }
    </Box>
  );
};

export default RedeemPage;
